define('StockInformation.View',
	[
		'stock_information_pdp.tpl',
		'StockInformation.Model',
		'SCView'
	],
	function (
		stock_information_pdp_tpl,
		StockInformationModel,
		SCViewComponent
	) {
		'use strict'

		var SCView = SCViewComponent.SCView;

		function StockInformationView(options) {
			SCView.call(this);

			this.options = options || {};

			this.template = stock_information_pdp_tpl;

			this.initialize = function initialize(options) {
				var self = this;
				self.itemInfo = options.itemInfo;
				if(self.itemInfo){
					var stockInformationModel = new StockInformationModel();
					var itemInternalId = self.itemInfo.item.internalid;
	
					var environment = options.container.getComponent('Environment');
					self.stockInformation = environment.getConfig('StockInformation');
	
					self.isCoreRequired = self.itemInfo.item.custitem_jc_corerequired;
					self.storeDisplayName = self.itemInfo.item.storedisplayname2;
	
					stockInformationModel.fetch({
						data:{
							itemInternalId: itemInternalId
						}
					}).done(function(response){
						if(response && response.length){
							self.stockMessage = '';
							self.stockMessageIdentifier = '';
							var currentAvailableQuantity = response[0].availableQuantity;
	
							if(currentAvailableQuantity == self.stockInformation['outOfStockQuantity']){
								self.stockMessage = self.stockInformation['outOfStock'];
								self.stockMessageIdentifier = 'outOfStock';
							}else if(currentAvailableQuantity > self.stockInformation['outOfStockQuantity'] && currentAvailableQuantity < self.stockInformation['inStockQuantity']){
								self.stockMessage = currentAvailableQuantity + ' ' + self.stockInformation['lowStock'];
								self.stockMessageIdentifier = 'lowStock';
							}else{
								self.stockMessage = self.stockInformation['inStock'];
								self.stockMessageIdentifier = 'inStock';
							}
						}
						self.stockQuantity = response;
						self.render();
					})
				}
			}

			this.initialize(options);
		}

		StockInformationView.prototype = Object.create(SCView.prototype);

		StockInformationView.prototype.constructor = StockInformationView;

		StockInformationView.prototype.getContext = function getContext() {
			this.showSection = true;
			if(this.isCoreRequired || (this.storeDisplayName.toUpperCase().indexOf('"MUST HAVE CORE"') != -1)){
				this.showSection = false;
			}
			return {
				stockMessage: this.stockMessage,
				stockMessageIdentifier: this.stockMessageIdentifier,
				showSection: this.showSection
			};
		}
		return StockInformationView;
	}
);
